var App = App || {};

App.HomepageBanner = (function ($) {
    "use strict";

    function init() {

        const homepageBanners = $(".widget.widget-homepage-banner");
        if (homepageBanners.length) {
            homepageBanners.each(function () {
                initHomepageBanner($(this));
            });
        }
    }

    function initHomepageBanner(homepageBanner) {
        const cardArea = homepageBanner.find(".cards")
        const navArea = homepageBanner.find(".card-nav");
        const cardCount = navArea.attr("data-count");
        const prevBtn = homepageBanner.find(".hpb-prev");
        const nextBtn = homepageBanner.find(".hpb-next");
        const toggleBtn = homepageBanner.find(".hpb-toggle");

        var interval;
        var process = true;

        var timer = function () {
            interval = setInterval(function () {
                if (process) {
                    nextSlide(cardArea, navArea, cardCount);
                }
            }, 4000);
        };
        timer();

        nextBtn.on("click", function () {
            nextSlide(cardArea, navArea, cardCount);

            clearInterval(interval);
            timer();
        });

        prevBtn.on("click", function () {
            prevSlide(cardArea, navArea, cardCount);

            clearInterval(interval);
            timer();
        });

        toggleBtn.on("click", function () {
            $(this).toggleClass("play");
            process = !process;

            clearInterval(interval);
            timer();
        });

        homepageBanner.ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".cards", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });
    }

    function prevSlide(cardArea, navArea, cardCount) {
        var currentCard = navArea.find(".card-text.active");

        currentCard.removeClass("active");
        cardArea.find(".homepage-banner-card.active").removeClass("active");

        var currentIndex = currentCard.attr("data-index");
        var prevIndex = cardCount;
        if (currentIndex != 1) {
            prevIndex = parseInt(currentIndex) - 1;
        }

        navArea.find(".card-text[data-index=" + prevIndex + "]").addClass("active");
        cardArea.find(".homepage-banner-card[data-index=" + prevIndex + "]").addClass("active");
    }

    function nextSlide(cardArea, navArea, cardCount) {
        var currentCard = navArea.find(".card-text.active");

        currentCard.removeClass("active");
        cardArea.find(".homepage-banner-card.active").removeClass("active");

        var currentIndex = currentCard.attr("data-index");
        var nextIndex = 1;
        if (currentIndex != cardCount) {
            nextIndex = parseInt(currentIndex) + 1;
        }

        navArea.find(".card-text[data-index=" + nextIndex + "]").addClass("active");
        cardArea.find(".homepage-banner-card[data-index=" + nextIndex + "]").addClass("active");
    }

    return {
        init: init,
        initHomepageBanner: initHomepageBanner
    };

})(jQuery);

$(function () {
    App.HomepageBanner.init();
});